<template>
  <nav class="border-b border-gray-lighter">
    <ul class="flex -mb-px">
      <li
        v-for="(tab, index) in tabs"
        :key="tab.value"
        @click="switchTab(tab.value)"
        class="px-1 py-4 whitespace-no-wrap border-b-2 select-none"
        :class="[
          { 'ml-4': index > 0 },
          value === tab.value
            ? 'border-brand-darker text-brand'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 cursor-pointer'
        ]"
      >
        <a class="font-medium whitespace-no-wrap">
          <span>{{ tab.text }}</span>

          <UtilBadgeCount
            v-if="typeof tab.count !== 'undefined'"
            :count="tab.count"
            showIfZero
            :unread="false"
            gray
            class="ml-1 sm:ml-2"
          />
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import UtilBadgeCount from '@/components/utils/UtilBadgeCount'

export default {
  name: 'UtilTabs',
  components: {
    UtilBadgeCount
  },
  props: {
    value: [String, Number],
    tabs: {
      type: Array,
      required: true
    },
    targetClass: String
  },
  methods: {
    switchTab(tab) {
      this.$emit('input', tab)
      this.$emit('switchTab', tab)
    }
  }
}
</script>

<style lang="scss" scoped>
.tab {
  @apply py-2 px-4 inline-block select-none;
  @apply text-gray-darker font-semibold cursor-pointer;

  &:hover {
    @apply text-gray-darker;
  }
}

#app.xs .tab {
  @apply px-2 flex flex-no-wrap items-center;
}

.tab.active {
  @apply text-primary border-l border-t border-r border-gray rounded-t -mb-px;
}

.tab-text {
  line-height: 25px;
}
</style>
